import type { ImdgSubstance, SubstanceVerificationResult } from '@/shared/api/types';

export interface ValidationResult extends Omit<
  SubstanceVerificationResult,
  'autoSelectedSubstanceId'
> {
  autoSelectedSubstanceId?: string;
  selectedSubstance?: ImdgSubstance;
}

export function createEmptyValidationResult(cargoId?: string): ValidationResult {
  return {
    cargoId,
    validationStatus: undefined,
    substanceIds: [],
    selectedSubstanceId: null,
    selectedSubstance: undefined,
  };
}
